import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class GroupService extends BaseService {

  // http options used for making API calls
  private httpOptions: any;

  // error messages received from the login attempt
  public errors: any = [];
  project_labels = "";

  constructor(
      private httpClient: HttpClient
  ) {
      super();
      this.httpOptions = {
          headers: new HttpHeaders({ 'Content-Type': 'application/json' })
      };

      this.url_params["group"]            = "group/";
  }
  
  getGroups()
  {
      return this.httpClient.get<any>(this.getApiUrl() + this.url_params["group"],{ }).pipe(map((response: any) => response));
  }
    
}
